export type ComplexData = {
	id: number;
	common_name: string;
	scientific_name: string;
	conservation_status: string;
	habitat: string;
	diet: string;
	geographic_range: string;
};

const SPECIES: Omit<ComplexData, 'id'>[] = [
	{
		common_name: 'African elephant',
		scientific_name: 'Loxodonta africana',
		conservation_status: 'Vulnerable',
		habitat: 'Savannas and forests',
		diet: 'Herbivore',
		geographic_range: 'Sub-Saharan Africa',
	},
	{
		common_name: 'American bison',
		scientific_name: 'Bison bison',
		conservation_status: 'Near Threatened',
		habitat: 'Grasslands and plains',
		diet: 'Herbivore',
		geographic_range: 'North America',
	},
	{
		common_name: 'Arctic fox',
		scientific_name: 'Vulpes lagopus',
		conservation_status: 'Least Concern',
		habitat: 'Tundra',
		diet: 'Omnivore',
		geographic_range: 'Arctic Circle',
	},
	{
		common_name: 'Atlantic puffin',
		scientific_name: 'Fratercula arctica',
		conservation_status: 'Vulnerable',
		habitat: 'Coastal cliffs and open ocean',
		diet: 'Carnivore',
		geographic_range: 'North Atlantic Ocean',
	},
	{
		common_name: 'Bengal tiger',
		scientific_name: 'Panthera tigris tigris',
		conservation_status: 'Endangered',
		habitat: 'Tropical forests and grasslands',
		diet: 'Carnivore',
		geographic_range: 'Indian subcontinent',
	},
	{
		common_name: 'Black rhinoceros',
		scientific_name: 'Diceros bicornis',
		conservation_status: 'Critically Endangered',
		habitat: 'Savannas and shrublands',
		diet: 'Herbivore',
		geographic_range: 'Eastern and Southern Africa',
	},
	{
		common_name: 'Blue whale',
		scientific_name: 'Balaenoptera musculus',
		conservation_status: 'Endangered',
		habitat: 'Open ocean',
		diet: 'Carnivore',
		geographic_range: 'Global oceans',
	},
	{
		common_name: 'California condor',
		scientific_name: 'Gymnogyps californianus',
		conservation_status: 'Critically Endangered',
		habitat: 'Cliffs and scrublands',
		diet: 'Scavenger',
		geographic_range: 'Western United States',
	},
	{
		common_name: 'Cheetah',
		scientific_name: 'Acinonyx jubatus',
		conservation_status: 'Vulnerable',
		habitat: 'Grasslands and savannas',
		diet: 'Carnivore',
		geographic_range: 'Africa and Iran',
	},
	{
		common_name: 'Emperor penguin',
		scientific_name: 'Aptenodytes forsteri',
		conservation_status: 'Near Threatened',
		habitat: 'Sea ice and open ocean',
		diet: 'Carnivore',
		geographic_range: 'Antarctica',
	},
	{
		common_name: 'Galápagos tortoise',
		scientific_name: 'Chelonoidis niger',
		conservation_status: 'Vulnerable',
		habitat: 'Volcanic highlands',
		diet: 'Herbivore',
		geographic_range: 'Galápagos Islands',
	},
	{
		common_name: 'Giant anteater',
		scientific_name: 'Myrmecophaga tridactyla',
		conservation_status: 'Vulnerable',
		habitat: 'Grasslands and forests',
		diet: 'Insectivore',
		geographic_range: 'Central and South America',
	},
	{
		common_name: 'Giant panda',
		scientific_name: 'Ailuropoda melanoleuca',
		conservation_status: 'Vulnerable',
		habitat: 'Temperate bamboo forests',
		diet: 'Herbivore',
		geographic_range: 'Central China',
	},
	{
		common_name: 'Golden eagle',
		scientific_name: 'Aquila chrysaetos',
		conservation_status: 'Least Concern',
		habitat: 'Mountains and open plains',
		diet: 'Carnivore',
		geographic_range: 'Northern Hemisphere',
	},
	{
		common_name: 'Gray wolf',
		scientific_name: 'Canis lupus',
		conservation_status: 'Least Concern',
		habitat: 'Forests and tundra',
		diet: 'Carnivore',
		geographic_range: 'Northern Hemisphere',
	},
	{
		common_name: 'Great white shark',
		scientific_name: 'Carcharodon carcharias',
		conservation_status: 'Vulnerable',
		habitat: 'Coastal and offshore waters',
		diet: 'Carnivore',
		geographic_range: 'Global temperate seas',
	},
	{
		common_name: 'Green sea turtle',
		scientific_name: 'Chelonia mydas',
		conservation_status: 'Endangered',
		habitat: 'Coastal waters and beaches',
		diet: 'Herbivore',
		geographic_range: 'Tropical and subtropical oceans',
	},
	{
		common_name: 'Harpy eagle',
		scientific_name: 'Harpia harpyja',
		conservation_status: 'Near Threatened',
		habitat: 'Tropical rainforests',
		diet: 'Carnivore',
		geographic_range: 'Central and South America',
	},
	{
		common_name: 'Humpback whale',
		scientific_name: 'Megaptera novaeangliae',
		conservation_status: 'Least Concern',
		habitat: 'Open ocean',
		diet: 'Carnivore',
		geographic_range: 'Global oceans',
	},
	{
		common_name: 'Jaguar',
		scientific_name: 'Panthera onca',
		conservation_status: 'Near Threatened',
		habitat: 'Tropical rainforests and wetlands',
		diet: 'Carnivore',
		geographic_range: 'Central and South America',
	},
	{
		common_name: 'Koala',
		scientific_name: 'Phascolarctos cinereus',
		conservation_status: 'Vulnerable',
		habitat: 'Eucalyptus woodlands',
		diet: 'Herbivore',
		geographic_range: 'Eastern Australia',
	},
	{
		common_name: 'Monarch butterfly',
		scientific_name: 'Danaus plexippus',
		conservation_status: 'Endangered',
		habitat: 'Prairies and meadows',
		diet: 'Herbivore',
		geographic_range: 'North America',
	},
	{
		common_name: 'Mountain gorilla',
		scientific_name: 'Gorilla beringei beringei',
		conservation_status: 'Endangered',
		habitat: 'Montane forests',
		diet: 'Herbivore',
		geographic_range: 'Central Africa',
	},
	{
		common_name: 'Narwhal',
		scientific_name: 'Monodon monoceros',
		conservation_status: 'Near Threatened',
		habitat: 'Arctic waters',
		diet: 'Carnivore',
		geographic_range: 'Arctic Circle',
	},
	{
		common_name: 'Okapi',
		scientific_name: 'Okapia johnstoni',
		conservation_status: 'Endangered',
		habitat: 'Rainforests',
		diet: 'Herbivore',
		geographic_range: 'Democratic Republic of the Congo',
	},
	{
		common_name: 'Polar bear',
		scientific_name: 'Ursus maritimus',
		conservation_status: 'Vulnerable',
		habitat: 'Sea ice and tundra',
		diet: 'Carnivore',
		geographic_range: 'Arctic Circle',
	},
	{
		common_name: 'Red kangaroo',
		scientific_name: 'Osphranter rufus',
		conservation_status: 'Least Concern',
		habitat: 'Deserts and grasslands',
		diet: 'Herbivore',
		geographic_range: 'Australia',
	},
	{
		common_name: 'Red panda',
		scientific_name: 'Ailurus fulgens',
		conservation_status: 'Endangered',
		habitat: 'Temperate forests',
		diet: 'Omnivore',
		geographic_range: 'Eastern Himalayas',
	},
	{
		common_name: 'Snow leopard',
		scientific_name: 'Panthera uncia',
		conservation_status: 'Vulnerable',
		habitat: 'Mountain ranges',
		diet: 'Carnivore',
		geographic_range: 'Central and South Asia',
	},
	{
		common_name: 'Southern cassowary',
		scientific_name: 'Casuarius casuarius',
		conservation_status: 'Least Concern',
		habitat: 'Tropical rainforests',
		diet: 'Omnivore',
		geographic_range: 'New Guinea and northeastern Australia',
	},
	{
		common_name: 'Tasmanian devil',
		scientific_name: 'Sarcophilus harrisii',
		conservation_status: 'Endangered',
		habitat: 'Forests and coastal scrub',
		diet: 'Carnivore',
		geographic_range: 'Tasmania',
	},
	{
		common_name: 'Yellow-eyed penguin',
		scientific_name: 'Megadyptes antipodes',
		conservation_status: 'Endangered',
		habitat: 'Coastal forests and beaches',
		diet: 'Carnivore',
		geographic_range: 'New Zealand',
	},
];

export const COMPLEX_DATA: ComplexData[] = Array.from({ length: 200 }, (_, index) => {
	const species = SPECIES[index % SPECIES.length];

	return {
		id: index + 1,
		...species,
	};
});

export function configurableData(size: number): ComplexData[] {
	return Array.from({ length: size }, (_, index) => {
		const species = SPECIES[index % SPECIES.length];

		return {
			id: index + 1,
			...species,
		};
	});
}
